import {$document, APP_NAME} from '../utils/environment';
import AbstractModule from './AbstractModule';
import {Recaptcha} from '../utils/captcha';

const MODULE_NAME = 'LibraryForm';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties
        this.components = options.form_components;
    }

    init() {
        if ($('.js-captcha').length) {
            Recaptcha.setInputElement($('.js-captcha'));
        }
        // Set events and such
        var link = document.createElement('link');
        // set the attributes for link element
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = 'assets/styles/formio.css';
        document.getElementsByTagName('HEAD')[0].appendChild(link);

        Formio.icons = 'fontawesome';

        // Set events and such
        let form = Formio.createForm(this.el, this.components, {
            nosubmit: true,
            language: 'fr',
            i18n: {
                resources: {
                    fr: {
                        translation: {
                            'complete': 'Soumission complétée',
                            'day': 'jour',
                            'month': 'mois',
                            'year': 'année',
                            'january': 'janvier',
                            'february': 'février',
                            'march': 'mars',
                            'april': 'avril',
                            'may': 'mai',
                            'june': 'juin',
                            'july': 'juillet',
                            'august': 'août',
                            'september': 'septembre',
                            'october': 'octobre',
                            'november': 'novembre',
                            'december': 'décembre'

                        }
                    }
                }
            },
            hooks: {

            }
        }).then((form) => {
            form.on('submit', (submission) => {

                Recaptcha.execute(() => {

                    // Manually adding the recaptcha token to the submitted data
                    submission['g-recaptcha-response'] = Recaptcha.value;
                    fetch('/contact/library-request', {
                        body:    JSON.stringify(submission),
                        headers: {
                            'content-type': 'application/json'
                        },
                        method:  'POST',
                        mode:    'cors',
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                form.emit('submitDone', submission);
                                $document.triggerHandler({
                                    type:    'scrollTo.LocomotiveScroll',
                                    options: {
                                        targetElem: $('.js-form-container'),
                                        speed:      600
                                    }
                                });
                                this.$el.css('display', 'none');
                                this.triggerFeedback('Votre requête est envoyée!');
                            } else {
                                this.triggerFeedback('Veuillez vérifier que tous les champs requis sont remplis.');
                            }
                        })
                        .catch(errors => {
                            this.triggerFeedback('Une erreur est survenue. Veuillez réessayer plus tard.');
                        });
                }, () => {
                    // Recaptcha error
                    // @todo add validation
                    this.triggerFeedback('Une erreur est survenue. Veuillez réessayer plus tard.');
                })
            });
        })
    }


    triggerFeedback(feedback) {
        $('.js-form-feedback').html(
            '<p class="o-h2">'+feedback+'</p>'
        ).addClass('is-visible');
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
